import React, { useEffect, useState } from 'react';
import { useCookies, withCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import Header from '../components/Header';

const LoginComponent = ({ api }) => {
  const navigate = useNavigate()

  const [cookies, setCookie] = useCookies([])
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [emailInputVisible, setEmailInputVisible] = useState(false);

  // AuthContext handles redirecting authenticated users

  const handleEmailSubmit = async (e) => {
    e.preventDefault()

    if (!loading) {
      setLoading(true)
      setError('')

      try {
        const resp = await api().getCode({email})

        if (resp.status === 200) {
          // Navigate to verify page with email in state
          navigate('/login/verify', { state: { email } })
        }
      } catch (error) {
        setError('Failed to send code. Please check your email and try again.')
      }

      setLoading(false)
    }
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true)
    try {
      const res = await api().loginWithGoogle(credentialResponse.credential)

      if (res.status === 200) {
        setCookie('token', res.data.authToken, { path: '/' })

        if (!res.data.user.onboardingComplete) {
          navigate('/onboarding')
        } else {
          navigate('/home')
        }
      }
    } catch (error) {
      setError('Google sign-in failed. Please try again.')
    }
    setLoading(false)
  }

  const handleGoogleError = () => {
    setError('Google sign-in failed. Please try again.')
  }

  return (
    <div className="bg-gradient-to-b from-blue-400 to-green-700 min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full">
        <h2 className="text-2xl font-semibold mb-6 text-center">Log in or sign up</h2>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}

        {/* Google OAuth Button */}
        <div className="mb-4 w-full flex justify-center px-4">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            theme="outline"
            size="large"
            text="signin_with"
            width="320"
          />
        </div>

        {/* Toggle Email Input */}
        <div className="text-center my-4">
          <button
            type="button"
            onClick={() => setEmailInputVisible(!emailInputVisible)}
            disabled={loading}
            className="text-sm text-gray-500 hover:text-gray-700 hover:underline cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {emailInputVisible ? 'hide email option' : 'or sign in with email'}
          </button>
        </div>

        {/* Email Input Form */}
        {emailInputVisible && (
          <div className="border-t border-gray-200 pt-6">
            <form onSubmit={handleEmailSubmit}>
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-2 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button
                disabled={loading}
                type="submit"
                className={
                  loading
                    ? "w-full p-2 bg-gray-200 text-white rounded-md focus:outline-none"
                    : "w-full p-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none"
                }
              >
                {loading ? 'Sending code...' : 'Continue with email'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

const Login = withCookies(({ api }) => (
  <div>
    <Header api={api} />
    <LoginComponent api={api} />
  </div>
))

export default Login;
